import { useQuery } from '@tanstack/react-query';
import { catalogApi } from '@/api/endpoints/catalog';

/** Справочники фильтров (CAT-2): категории с детьми, хуки, типы переходов. */
export function useFilterOptions() {
  return useQuery({
    queryKey: ['filter-options'],
    queryFn: () => catalogApi.filterOptions(),
    select: (response) => response.data,
    staleTime: 10 * 60_000,
  });
}
